import React, { Suspense, lazy } from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import { Layout } from './components/common/Layout';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import SeoHreflang from './components/common/SeoHreflang';

const Loader = () => <div className="loading-screen"><div className="spinner" /></div>;

// Pages
const Home = lazy(() => import('./pages/Home'));
const Login = lazy(() => import('./pages/Login'));
const Register = lazy(() => import('./pages/Register'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const LoginSuccess = lazy(() => import('./pages/LoginSuccess'));
const Fortune = lazy(() => import('./pages/Fortune'));
const Tarot = lazy(() => import('./pages/Tarot'));
const TarotResult = lazy(() => import('./pages/TarotResult'));
const Gunghap = lazy(() => import('./pages/Gunghap'));
const Privacy = lazy(() => import('./pages/Privacy'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const Terms = lazy(() => import('./pages/Terms'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));
const RefundPolicy = lazy(() => import('./pages/RefundPolicy'));
const Result = lazy(() => import('./pages/Result'));
const Charge = lazy(() => import('./pages/Charge'));
const PaymentSuccess = lazy(() => import('./pages/PaymentSuccess'));
const PaymentFail = lazy(() => import('./pages/PaymentFail'));
const AdminERP = lazy(() => import('./pages/AdminERP'));
const FamousSajuList = lazy(() => import('./pages/FamousSajuList'));
const Reviews = lazy(() => import('./pages/Reviews'));

function App() {
  return (
    <Suspense fallback={<Loader />}>
      <SeoHreflang />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/login-success" element={<LoginSuccess />} />
          <Route path="/fortune" element={<Fortune />} />
          <Route path="/famous-saju" element={<FamousSajuList />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/result" element={<Result />} />
          <Route path="/tarot" element={<Tarot />} />
          <Route path="/tarot-result" element={<TarotResult />} />
          <Route path="/gunghap" element={<Gunghap />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/charge" element={<Charge />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-fail" element={<PaymentFail />} />
          <Route path="/admin" element={<ProtectedRoute><AdminERP /></ProtectedRoute>} />
          <Route path="/admin/erp" element={<ProtectedRoute><AdminERP /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
